$(document).on "click", ".dropdown-container", (e) ->
  $el = $(e.currentTarget)
  # do not close dropdown if it's active and
  # has the class to stay open
  unless $el.is(".active.dropdown-stay-open")
    $(".dropdown-container").not($el).removeClass "active"
    if !$el.hasClass("dropdown-on-hover")
      # if the dropdown is not hover only
      $el.toggleClass "active"

    if contently.ui.touch_device
      # but if it's a touch device, just always active
      $el.addClass "active"

$(document).on "click", (e) ->
  if !$(e.target).is(".dropdown-container *")
    $(".dropdown-container.active").removeClass "active"



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/dropdowns.js.coffee